(function (window, document, $) {

    $(document).ready(function () {
        // custom checkboxes
        if ($('input[type="checkbox"]').length) {
            $('input[type="checkbox"]').each(function () {
                // fix for filter checkboxes  
                if ($(this).parent('.filter__input-group').length) {
                    return;
                }

                if ($(this).parent('.wpgu-onboarding-answer').length) {
                    return;
                }

                $(this).addClass('checkbox-custom');

                if ($(this).next('span').length) {
                    return;
                }

                $('<span class="checkbox-button"></span>').insertAfter(this);
            });

            $('span.checkbox-button').on('click', function () {
                var checkboxbutton = $(this).prev('input[type="checkbox"]');

                if (!checkboxbutton.parent('label').length) {
                    $(checkboxbutton).trigger('click');
                }
            });
        }
    });

}(window, document, jQuery));
